import builder from '../builder';
import RealEstateHouse from '../../streamline-icons/light/real-estate-house.svg';

export default builder('IconRealEstateHouseLight', RealEstateHouse);
